import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {ApiLessonsStudentsResponse} from "../../../../types/lessonsStudents";
import {setLessonsStudents} from "../../../../slice/groups/set-lessons-students/setLessonsStudents";



export const fetchLessonsIdStudents = createAsyncThunk(
    "lessons/fetchLessonsId",
    async (lessonsId:string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<ApiLessonsStudentsResponse>(`/api/lessons/${lessonsId}/students`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setLessonsStudents(response.data.data));

            }


            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);